import React from 'react';
import { CommunityPageSectionRow } from '@/types/cms';
import { 
  HeroSection, 
  GridSection, 
  VideoSection, 
  TextBlockSection, 
  CTASection 
} from './index';

interface SectionRendererProps {
  section: CommunityPageSectionRow;
  className?: string;
  isPreview?: boolean;
}

const SectionRenderer: React.FC<SectionRendererProps> = ({ section, className, isPreview = false }) => {
  const { section_type, content } = section;

  switch (section_type) {
    case 'hero':
      return <HeroSection section={section} content={content} className={className} isPreview={isPreview} />;
    
    case 'grid':
      return <GridSection section={section} content={content} className={className} isPreview={isPreview} />;
    
    case 'video':
      return <VideoSection section={section} content={content} className={className} isPreview={isPreview} />;
    
    case 'text_block':
      return <TextBlockSection section={section} content={content} className={className} isPreview={isPreview} />;
    
    case 'cta':
      return <CTASection section={section} content={content} className={className} isPreview={isPreview} />;
    
    case 'image_text':
      // TODO: Implement ImageTextSection component
      return (
        <div className="py-16 px-4 text-center text-muted-foreground">
          <p>Image + Text section coming soon</p>
        </div>
      );
    
    case 'custom':
      // TODO: Implement CustomSection component for advanced use cases
      return (
        <div className="py-16 px-4 text-center text-muted-foreground">
          <p>Custom section type not implemented</p>
        </div>
      );
    
    default:
      return (
        <div className="py-16 px-4 text-center text-muted-foreground">
          <p>Unknown section type: {section_type}</p>
        </div>
      );
  }
};

export default SectionRenderer;